var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('DashBoard',{attrs:{"TIME":"BÁO CÁO SAIGON CHILL"}}),_c('vue-headful',{attrs:{"title":"BÁO CÁO SAIGON CHILL"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }